import { useQueryClient } from '@tanstack/react-query'
import { LogOut } from 'lucide-react'
import { ThemeToggle } from '@shared/design-system/ui'
import { useSession } from '@shared/lib/auth/session-store'
import {
  brandLogo,
  brandLogoDark,
  brandLogoLight,
  iconButton,
  platformBadge,
  topbar,
  topbarBrand,
  topbarRight,
  userChip,
} from './AppShell.css'

function getInitials(name: string | undefined): string {
  if (!name) {
    return 'VP'
  }
  const letters = name
    .trim()
    .split(/\s+/)
    .map((part) => part.charAt(0))
    .join('')
  const initials = (
    letters.charAt(0) + (letters.length > 1 ? letters.charAt(letters.length - 1) : '')
  ).toUpperCase()
  return initials || 'VP'
}

export function Topbar() {
  const user = useSession((state) => state.user)
  const clearSession = useSession((state) => state.clear)
  const queryClient = useQueryClient()

  function handleLogout() {
    clearSession()
    queryClient.clear()
    window.location.assign('/login')
  }

  return (
    <header className={topbar} data-testid="topbar">
      <span className={topbarBrand}>
        <img
          className={`${brandLogo} ${brandLogoLight}`}
          src="/brand/logo-full.png"
          alt="VendePay"
        />
        <img
          className={`${brandLogo} ${brandLogoDark}`}
          src="/brand/logo-full-claro.png"
          alt="VendePay"
        />
        <span className={platformBadge}>Player</span>
      </span>
      <div className={topbarRight}>
        <ThemeToggle />
        <span className={userChip}>{getInitials(user?.name)}</span>
        <button type="button" className={iconButton} aria-label="Sair" onClick={handleLogout}>
          <LogOut size={17} />
        </button>
      </div>
    </header>
  )
}
